import { api } from '../lib/api-client.js';

export interface PlacesPrediction {
  placeId: string;
  mainText: string;
  secondaryText: string;
  description: string;
}

export interface PlaceAddressDetail {
  placeId: string;
  formattedAddress: string;
  addressLine1: string;
  city: string;
  state: string;
  postalCode: string;
  country: string | null;
  latitude: number | null;
  longitude: number | null;
}

export async function fetchPlacesConfigured(): Promise<boolean> {
  const r = await api<{ enabled: boolean }>('/places/configured');
  return r.enabled;
}

export async function autocompletePlaces(
  q: string,
  sessionToken: string,
): Promise<{ predictions: PlacesPrediction[]; disabled?: boolean }> {
  const params = new URLSearchParams({ q, sessionToken });
  return api(`/places/autocomplete?${params.toString()}`);
}

export async function fetchPlaceDetails(
  placeId: string,
  sessionToken: string,
): Promise<PlaceAddressDetail> {
  const params = new URLSearchParams({ sessionToken });
  const r = await api<{ place: PlaceAddressDetail }>(
    `/places/details/${encodeURIComponent(placeId)}?${params.toString()}`,
  );
  return r.place;
}
